import React, { useState } from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { ChevronDown, Globe } from 'lucide-react';
import { Language } from '../types/i18n';

const LanguageSelector: React.FC = () => {
    const { currentLanguage, changeLanguage } = useLanguage();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const languages: Language[] = [
        { code: 'fr', name: 'Français', flag: '🇫🇷' },
        { code: 'en', name: 'English', flag: '🇬🇧' },
  //      { code: 'ar', name: 'العربية', flag: '🇸🇦' }
    ];

    const currentLang = languages.find(lang => lang.code === currentLanguage);

    const handleLanguageChange = (langCode: string): void => {
        changeLanguage(langCode);
        setIsOpen(false);
    };

    const toggleDropdown = (): void => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="relative">
            <button
                onClick={toggleDropdown}
                className="flex items-center space-x-2 px-3 py-2 text-gray-600 hover:text-[#115DF2] transition-colors"
                type="button"
                aria-label="Select language"
            >
                <Globe className="w-4 h-4" />
                <span className="text-sm">{currentLang?.flag} {currentLang?.name}</span>
                <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {isOpen && (
                <div className="absolute top-full right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 min-w-[150px]">
                    {languages.map((lang: Language) => (
                        <button
                            key={lang.code}
                            onClick={() => handleLanguageChange(lang.code)}
                            className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg flex items-center space-x-2 ${
                                currentLanguage === lang.code ? 'bg-[#115DF2] text-white' : 'text-gray-700'
                            }`}
                            type="button"
                        >
                            <span>{lang.flag}</span>
                            <span>{lang.name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSelector;